import React from 'react'
import {render} from 'react-dom'
import Main from './redux/Main'
import './css/style.css'
render(<Main/>,document.getElementById("root"))
